import React from 'react';
import { connect } from 'react-redux';
import { injectIntl, defineMessages } from 'react-intl';
import SectionTitle from '../../../../components/SectionTitle';
import SecondaryNav from '../../../../components/SecondaryNav';
import { hasGrants } from '../../../../js/me/selectors';

const messages = defineMessages({
  title: {
    id: 'PbxVirtualOperator.title',
    defaultMessage: 'Virtual operator',
  },
  customer: {
    id: 'PbxVirtualOperator.customer.navLabel',
    defaultMessage: 'Enterprise',
  },
  users: {
    id: 'PbxVirtualOperator.users.navLabel',
    defaultMessage: 'Users',
  },
  offices: {
    id: 'PbxVirtualOperator.offices.navLabel',
    defaultMessage: 'Offices',
  },
  messages: {
    id: 'PbxVirtualOperator.messages.navLabel',
    defaultMessage: 'Messages',
  },
  treeQuestions: {
    id: 'PbxVirtualOperator.treeQuestions.navLabel',
    defaultMessage: 'Questions tree',
  },
  whatsappQuestions: {
    id: 'PbxVirtualOperator.whatsappQuestions.navLabel',
    defaultMessage: 'Whatsapp',
  },
  callQuestions: {
    id: 'PbxVirtualOperator.callQuestions.navLabel',
    defaultMessage: 'Calls',
  },
  monitoring: {
    id: 'PbxVirtualOperator.monitoring.navLabel',
    defaultMessage: 'Monitoring',
  },
  statistics: {
    id: 'PbxVirtualOperator.statistics.navLabel',
    defaultMessage: 'Statistics',
  },
  costs: {
    id: 'PbxVirtualOperator.costs.navLabel',
    defaultMessage: 'Costs resume',
  },
  list: {
    id: 'PbxVirtualOperator.list.navLabel',
    defaultMessage: 'List',
  },
  settings: {
    id: 'PbxVirtualOperator.settings.navLabel',
    defaultMessage: 'Settings',
  },
  ambrogioCosts: {
    id: 'PbxVirtualOperator.ambrogioCosts.navLabel',
    defaultMessage: 'Customers costs',
  },
});

const PbxVirtualOperator = ({
  hasReadGrant,
  hasManagementGrant,
  hasAmbrogioGrant,
  intl: { formatMessage },
  children,
  scrolling,
}) => {
  const nav = [
    {
      id: 'PbxVirtualOperator.customer.linkLabel',
      href: '/pbx/virtual-operator/customer',
      label: messages.customer,
    },
    {
      id: 'PbxVirtualOperator.users.linkLabel',
      href: '/pbx/virtual-operator/users',
      label: messages.users,
    },
    {
      id: 'PbxVirtualOperator.offices.linkLabel',
      href: '/pbx/virtual-operator/offices',
      label: messages.offices,
    },
    {
      id: 'PbxVirtualOperator.messages.linkLabel',
      href: '/pbx/virtual-operator/messages',
      label: messages.messages,
    },
    {
      id: 'PbxVirtualOperator.treeQuestions.linkLabel',
      href: '/pbx/virtual-operator/questions-tree',
      label: messages.treeQuestions,
      subNav: [
        {
          id: 'PbxVirtualOperator.whatsappQuestions.navLabel',
          href: '/pbx/virtual-operator/whatsapp-questions',
          label: messages.whatsappQuestions,
        },
        /*{
          id: 'PbxVirtualOperator.callQuestions.navLabel',
          href: '/pbx/virtual-operator/call-questions',
          label: messages.callQuestions,
        },*/
      ],
    },
  ];
  const statisticsSubNav = [{
    id: 'PbxVirtualOperator.statistics.navLabel',
    href: '/pbx/virtual-operator/statistics/monitoring',
    label: messages.monitoring,
  },
  {
    id: 'PbxVirtualOperator.list.navLabel',
    href: '/pbx/virtual-operator/statistics/list',
    label: messages.list,
  }];
  if (hasManagementGrant) {
    statisticsSubNav.unshift({
      id: 'PbxVirtualOperator.costs.navLabel',
      href: '/pbx/virtual-operator/statistics/costs',
      label: messages.costs,
    });
  }
  if (hasReadGrant) {
    nav.push({
      id: 'PbxVirtualOperator.statistics.linkLabel',
      href: '/pbx/virtual-operator/statistics',
      label: messages.statistics,
      subNav: statisticsSubNav,
    });
  };
  if (hasManagementGrant) {
    nav.push(
    {
      id: 'PbxVirtualOperator.settings.linkLabel',
      href: '/pbx/virtual-operator/settings',
      label: messages.settings,
    },
    )
  }
  if (hasAmbrogioGrant) {
    nav.push({
      id: 'PbxVirtualOperator.ambrogioCosts.linkLabel',
      href: '/pbx/virtual-operator/ambrogio-costs',
      label: messages.ambrogioCosts,
    });
  }
  return (
    <div className="border rounded h-100 bg-white">
      <SectionTitle>{formatMessage(messages.title)}</SectionTitle>
      <SecondaryNav tabs={nav} />
      <div
        className={
          scrolling ? 'yn-section-with-nav-scrolling' : 'yn-section-with-nav'
        }
      >
        {children}
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    hasManagementGrant: hasGrants(state, 'MANAGE_VIRTUAL_OPERATOR'),
    hasReadGrant: hasGrants(state, 'VIEW_VIRTUAL_OPERATOR'),
    hasAmbrogioGrant: hasGrants(state, 'AMBROGIO_VIRTUAL_OPERATOR'),
  };
}

export default injectIntl(connect(mapStateToProps)(PbxVirtualOperator));
